import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Title from '../../components/common/Title';
import { Topbar } from '../../components/include/Topbar';
import Policies from '../../components/Settings/Policies';
import TermsConditions from '../../components/Settings/TermsConditions';
import Statement from '../../components/Settings/Statement';
import About from '../../components/Settings/About';
import Contactus from '../../components/Settings/Contactus';
import CmsList from '../../components/Settings/CmsList';
import ChangePassword from '../../components/Settings/ChangePassword';

const Settings_Main = () => {
     const [activeTab, setActiveTab] = useState("Policies");
      const location = useLocation();
      const tabs = ["Policies", "Statements", "Contact Us", "About Us", "Change Password" ];
      const navigate = useNavigate();
  
      const handleAddButtonClick = () => {
          if (activeTab === "Statements") {
              navigate("/education/performance/add");
          } else if (activeTab === "Contact Us") {
              navigate("/education/subject/add");
          } else if (activeTab === "About Us") {
              navigate("/education/facilities/add");
          } else if (activeTab === "Change Password") {
              navigate("/education/streams/add");
          }
      };
  
      const getAddButtonLabel = () => {
          switch (activeTab) {
              case "Statements":
                  return "+ Add Statements";
              case "Contact Us":
                  return "+ Add Subject";
              case "About Us":
                  return "+ Add Facility";
              case "Change Password":
                  return "+ Add Change Password";
              default:
                  return null;
          }
      };
  
      const handleTabClick = (tab) => {
          setActiveTab(tab);
      };
      useEffect(() => {
  
          if (location.state?.currentTab) {
            console.log("location.state?.currentTab",location.state?.currentTab)
              setActiveTab(location.state.currentTab);
          }
      }, [location.state?.currentTab]);
  

  return (
     <>

            <Title name="Settings" />
            <Topbar title="Settings & More" />
            <div className="p-6 space-y-6 pr-0">
                {/* Tabs */}
                <div className="flex justify-between flex-wrap gap-y-2">
                    <div className="flex gap-2 overflow-x-auto">
                        {tabs?.map((tab) => (
                            <button
                                key={tab}
                                className={`px-4 py-2 rounded-lg whitespace-nowrap ${activeTab === tab
                                    ? "bg-secondary_main text-white"
                                    : "bg-white text-black"
                                    }`}
                                onClick={() => handleTabClick(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                   


                </div>

                {/* Conditional Tab Content */}

                {activeTab === "Policies"  && (
                    <>
                        {/* <Policies/>
                        <TermsConditions/> */}
                        <CmsList/>
                    </>
                )}

                {activeTab === "Statements"  && (
                    <>
                        <Statement />
                    </>
                )}

                {activeTab === "Contact Us"  && (
                    <>
                        <Contactus/>

                    </>
                )}

                {activeTab === "About Us"  && (
                    <>
                        <About/>

                    </>
                )}
                {activeTab === "Change Password"  && (
                    <>
                       <ChangePassword/>
                    </>
                )}
              
            </div>
        </>
  )
}

export default Settings_Main